<script>
	export let danger = false
</script>

<button class:danger={danger}>
	<slot></slot>
</button>

<style>
	button {
		border: 0;
		border-radius: 24px;
		padding: 12px;
		background-color: #5551ff;
		cursor: pointer;
		font-weight: 700;
		margin-top: 2rem;
	}

	button.danger {
		background-color: #fc766a;
	}
</style>